<template>
    <span :class="cssClass">
        <a
            href="javascript:void(0)"
            :class="cssClass"
            @click.prevent="$emit('click')"
        >
            <i :class="icon"></i>
            <p>{{ label }}</p>
        </a>
    </span>
</template>

<script>
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        actionType: {
            type: Array,
            default: null,
        },
        cssClass: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
